import { FilterDimensionStatus } from '@Portal/models/smartFilters/FilterDimensionStatus';
import { FilterDimensionValue } from '@Portal/models/smartFilters/FilterDimensionValue';
import { SmartFilterDataType } from '@Portal/models/smartFilters/SmartFilterDataType';
import { SmartFilterType } from '@Portal/models/smartFilters/SmartFilterType';
import { DateTimePeriod } from '@Shared/types/portal/DateTimePeriod';
import dayjs from 'dayjs';

export class SmartFilter {
  filterName: string;
  filterKey: string;
  filterValue: string | DateTimePeriod;
  filterValueUpperBound?: string;
  filterDataType: SmartFilterDataType;
  filterType: SmartFilterType;
  filterSet?: string;
  filterDimensionValues?: FilterDimensionValue[];
  isSibling?: boolean;
  filterDimensionStatus?: FilterDimensionStatus;
  overrideFilterTransformerType?: string;

  constructor(
    filterKey: string,
    filterDataType: SmartFilterDataType,
    filterValue: string | DateTimePeriod,
    filterUpperBound?: string,
    overrideFilterTransformerType?: string
  ) {
    this.filterName = filterKey;
    this.filterKey = filterKey;
    this.filterValue = filterValue;
    this.filterDataType = filterDataType;
    this.filterValueUpperBound = filterUpperBound;
    this.filterType = SmartFilterType.Normal;
    this.overrideFilterTransformerType = overrideFilterTransformerType;
  }

  static toString(smartFilter: SmartFilter) {
    if (smartFilter.filterDataType === SmartFilterDataType.DateTime) {
      if (!smartFilter.filterValueUpperBound) return 'Invalid upper bound';
      return `${dayjs(smartFilter.filterValue).format('DD-MMM-YYYY')} - ${dayjs(
        smartFilter.filterValueUpperBound
      ).format('DD-MMM-YYYY')}`;
    } else {
      return smartFilter.filterValue;
    }
  }
}
